export const SET_PROJECT_CODE = 'SET_PROJECT_CODE';
export const GET_PROJECT_CODE = 'GET_PROJECT_CODE';
export const UPDATED_PROJECT_CODE = 'UPDATED_PROJECT_CODE';
export const SET_CURRENT_PROJECT_DETAILS = 'SET_CURRENT_PROJECT_DETAILS';
export const GET_CURRENT_PROJECT_DETAILS = 'GET_CURRENT_PROJECT_DETAILS';
export const SET_TEMPORARY_FILE_CHANGES = 'SET_TEMPORARY_FILE_CHANGES';
export const UPDATE_PROJECT_DETAILS = 'UPDATE_PROJECT_DETAILS';
export const SET_IFRAME_URL = 'SET_IFRAME_URL';
export const RESET_PROJECT_DETAILS = 'RESET_PROJECT_DETAILS';
export const SET_CODE_CHANGED = 'SET_CODE_CHANGED';
export const GET_PROJECT_NAME = 'GET_PROJECT_NAME';
export const SET_IS_CHAT_IN_PROGRESS = 'SET_IS_CHAT_IN_PROGRESS';
export const GET_IS_CHAT_IN_PROGRESS = 'GET_IS_CHAT_IN_PROGRESS';
export const CURRENT_CHAT_HISTORIES = 'CURRENT_CHAT_HISTORIES';
export const SET_CURRENT_CHAT_HISTORIES = 'SET_CURRENT_CHAT_HISTORIES';
export const SET_CONVERTING_PROJECT_ID = 'SET_CONVERTING_PROJECT_ID';
export const GET_CONVERTING_PROJECT_ID = 'GET_CONVERTING_PROJECT_ID';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_SELECTED_HTML_FILE = 'SET_SELECTED_HTML_FILE';
export const SET_DETECTED_ROUTES = 'SET_DETECTED_ROUTES';
export const SET_CONVERSATION_SUMMARY_PROMPT = 'SET_CONVERSATION_SUMMARY_PROMPT';
export const SET_ELEVENLABS_CONNECTION_STATUS = 'SET_ELEVENLABS_CONNECTION_STATUS';
export const SET_ELEVENLABS_SESSION_ID = 'SET_ELEVENLABS_SESSION_ID';
export const SET_PM_AGENT_DIALOG_OPEN = 'SET_PM_AGENT_DIALOG_OPEN';
export const SET_PM_AGENT_MESSAGES = 'SET_PM_AGENT_MESSAGES';
export const SET_PM_CONVERSATION_SUCCESSFUL = 'SET_PM_CONVERSATION_SUCCESSFUL';
export const SET_CURRENT_PM_SESSION_ID = 'SET_CURRENT_PM_SESSION_ID';
export const SET_CONVERSATION_STEP = 'SET_CONVERSATION_STEP';
export const ADD_NETWORK_ERROR = 'ADD_NETWORK_ERROR';
export const CLEAR_NETWORK_ERRORS = 'CLEAR_NETWORK_ERRORS';

export type ConversationStep = 'requirement-gathering' | 'product-manager' | 'prompt-enhancement';

export interface NetworkError {
    id: string;
    type: 'network';
    service: string;
    url: string;
    method: string;
    status?: number;
    error?: string;
    request?: any;
    response?: any;
    timestamp: string;
}

export const setProjectCode = (code: string) => ({
    type: SET_PROJECT_CODE,
    payload: code
});

export const updateProjectCode = (code: string) => ({
    type: UPDATED_PROJECT_CODE,
    payload: code
});

export const updateProjectDetails = (data: any) => ({
    type: UPDATE_PROJECT_DETAILS,
    payload: data
})

export const getProjectCode = () => ({
    type: GET_PROJECT_CODE,
    payload: null
});

export const getCurrentProjectDetails = () => ({
    type: GET_CURRENT_PROJECT_DETAILS,
    payload: null
})

export const setTemporaryChanges = (code: any) => ({
    type: SET_TEMPORARY_FILE_CHANGES,
    payload: code
})


export const setCurrentProjectDetails = (projectDetails: any) => ({
    type: SET_CURRENT_PROJECT_DETAILS,
    payload: projectDetails
})

export const setIframeUrl = (url: string) => ({
    type: SET_IFRAME_URL,
    payload: url
})


export const resetProjectDetails = () => ({
    type: RESET_PROJECT_DETAILS,
    payload: null
})

export const setCodeChanged = (codeChanged: boolean) => ({
    type: SET_CODE_CHANGED,
    payload: codeChanged
})

export const getProjectName = () => ({
    type: GET_PROJECT_NAME,
    payload: null
})

export const setIsChatInProgress = (isChatInProgress: boolean) => ({
    type: SET_IS_CHAT_IN_PROGRESS,
    payload: isChatInProgress
})

export const getIsChatInProgress = () => ({
    type: GET_IS_CHAT_IN_PROGRESS,
    payload: null
})

export const setCurrentChatHistories = (chatHistories: any) => ({
    type: SET_CURRENT_CHAT_HISTORIES,
    payload: chatHistories
})

export const setConvertingProjectId = (projectId: string) => ({
    type: SET_CONVERTING_PROJECT_ID,
    payload: projectId
})

export const setEditMode = (isEditMode: boolean) => ({
    type: SET_EDIT_MODE,
    payload: isEditMode
})

export const setSelectedHtmlFile = (fileName: string) => ({
    type: SET_SELECTED_HTML_FILE,
    payload: fileName
})

export const setDetectedRoutes = (routes: any) => ({
    type: SET_DETECTED_ROUTES,
    payload: routes
})

export const setConversationSummaryPrompt = (prompt: string) => ({
    type: SET_CONVERSATION_SUMMARY_PROMPT,
    payload: prompt
});

export const setElevenLabsConnectionStatus = (status: 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error') => ({
    type: SET_ELEVENLABS_CONNECTION_STATUS,
    payload: status
});

export const setElevenLabsSessionId = (sessionId: string | null) => ({
    type: SET_ELEVENLABS_SESSION_ID,
    payload: sessionId
});

export const setPmAgentDialogOpen = (isOpen: boolean) => ({
    type: SET_PM_AGENT_DIALOG_OPEN,
    payload: isOpen
});

export const setPmAgentMessages = (messages: any[]) => ({
    type: SET_PM_AGENT_MESSAGES,
    payload: messages
});

export const setPmConversationSuccessful = (isSuccessful: boolean) => ({
    type: SET_PM_CONVERSATION_SUCCESSFUL,
    payload: isSuccessful
});

export const setCurrentPmSessionId = (sessionId: string | null) => ({
    type: SET_CURRENT_PM_SESSION_ID,
    payload: sessionId
});

export const setConversationStep = (step: ConversationStep) => ({
    type: SET_CONVERSATION_STEP,
    payload: step
});

export const addNetworkError = (error: NetworkError) => ({
    type: ADD_NETWORK_ERROR,
    payload: error
});

export const clearNetworkErrors = () => ({
    type: CLEAR_NETWORK_ERRORS,
    payload: null
});